import api, { handleAPIErrors } from 'shared/api'

const FETCH_REQUEST = 'companies/FETCH_REQUEST'
const FETCH_SUCCESS = 'companies/FETCH_SUCCESS'
const FETCH_COMPANY_SUCCESS = 'companies/FETCH_COMPANY_SUCCESS'
const FETCH_FAILURE = 'companies/FETCH_FAILURE'

const FETCH_REPORT_REQUEST = 'companies/FETCH_REPORT_REQUEST'
const FETCH_COMPANY_REPORT_SUCCESS = 'companies/FETCH_COMPANY_REPORT_SUCCESS'
const FETCH_REPORT_FAILURE = 'companies/FETCH_REPORT_FAILURE'

const initialState = {
  companies: [],
  loadedCompanies: [],
  total_size: 0,
  loadedIds: [],
  loaded: false,
  loading: false,
  loadingReport: false,
  errors: [],
  companyReportData: {},
}

export function fetchRequest(payload = {}) {
  return {
    type: FETCH_REQUEST,
    loadedIds: payload.loadedIds,
  }
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchCompanySuccess(payload) {
  return {
    type: FETCH_COMPANY_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function fetchReportRequest(payload = {}) {
  return {
    type: FETCH_REPORT_REQUEST,
    loadedIds: payload.loadedIds,
  }
}

export function fetchCompanyReportSuccess(payload) {
  return {
    type: FETCH_COMPANY_REPORT_SUCCESS,
    payload,
  }
}

export function fetchReportFailure(errors = []) {
  return {
    type: FETCH_REPORT_FAILURE,
    errors,
  }
}

export function loadCompany(id, options = {}) {
  return (dispatch, getState) => {
    const state = getState()
    const loadedIds = state.companies.loadedIds ? state.companies.loadedIds.slice() : []
    if (!loadedIds.includes(id)) {
      loadedIds.push(id)
    }

    dispatch(fetchRequest({ loadedIds }))

    return api(`api/v1/companies/${id}`, options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchCompanySuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors))
        })
      })
  }
}

export function loadCompanies(options = {}) {
  return (dispatch) => {
    dispatch(fetchRequest())

    return api('api/v1/companies', options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors))
        })
      })
  }
}

export function loadCompanyReport(id, options = {}) {
  return (dispatch, getState) => {
    const state = getState()
    const loadedIds = state.companies.loadedIds ? state.companies.loadedIds.slice() : []
    if (!loadedIds.includes(id)) {
      loadedIds.push(id)
    }

    dispatch(fetchReportRequest({ loadedIds }))

    return api(`api/v1/companies/${id}/report`, options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchCompanyReportSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchReportFailure(errors))
        })
      })
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        loadedIds: action.loadedIds || state.loadedIds,
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        total_size: payload.total_size,
        errors: [],
        companies: [...payload.result]
      })
    case FETCH_COMPANY_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        errors: [],
        loadedCompanies: [
          ...state.loadedCompanies,
          payload
        ]
      })
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loaded: false,
        loading: false,
        errors,
      })
    case FETCH_REPORT_REQUEST:
      return Object.assign({}, state, {
        loadingReport: true,
        loadedIds: action.loadedIds || state.loadedIds,
      })
    case FETCH_COMPANY_REPORT_SUCCESS:
      return Object.assign({}, state, {
        loadingReport: false,
        errors: [],
        companyReportData: {
          ...payload
        },
      })
    case FETCH_REPORT_FAILURE:
      return Object.assign({}, state, {
        loaded: false,
        loadingReport: false,
        errors,
      })
    default:
      return state
  }
}

